import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface LoyaltyPointsDialogProps {
    open: boolean;
}

const initialState: LoyaltyPointsDialogProps = { open: false };

const loyaltyPointsDialogSlice = createSlice({
    name: 'loyaltyPointsDialog',
    initialState,
    reducers: {
        openLoyaltyPointsDialog: (state) => {
            state.open = true;
            return state;
        },
        closeLoyaltyPointsDialog: (state) => {
            state = initialState;
            return state;
        },
    },
});

export const { openLoyaltyPointsDialog, closeLoyaltyPointsDialog, } = loyaltyPointsDialogSlice.actions;
export default loyaltyPointsDialogSlice.reducer;
export const selectLoyaltyPointsDialog = (state: RootState) => state.loyaltyPointsDialog;